import React from "react";
import "./style.scss";

interface IProps {
  value: string;
  label: string;
  name: string;
  setValue: (value: string) => void;
  placeholder?: string;
  isError?: boolean;
}

const InputText: React.FC<IProps> = ({ value, label, name, setValue, placeholder, isError = false }: IProps) => {
  return (
    <div className={`form-input-text ${isError ? "input-error" : ""}`}>
      <label htmlFor={name}>{label}</label>
      <input
        type="text"
        value={value}
        name={name}
        onChange={event => setValue(event.target.value)}
        placeholder={placeholder}
      />
    </div>
  );
};

export default InputText;
